"use client"

import Link from "next/link"
import type { ComponentProps } from "react"
import type { YohoCustomEventName } from "@/lib/analytics/events"
import type { AnalyticsParams } from "@/lib/analytics/track"
import { trackYohoEvent } from "@/lib/analytics/track"

type AnalyticsClickLinkProps = ComponentProps<typeof Link> & {
  eventName: YohoCustomEventName
  eventParams: AnalyticsParams
}

export function AnalyticsClickLink({ eventName, eventParams, onClick, ...props }: AnalyticsClickLinkProps) {
  return (
    <Link
      {...props}
      onClick={(event) => {
        trackYohoEvent(eventName, eventParams)
        onClick?.(event)
      }}
    />
  )
}
